<template>
  <v-form @submit="onSubmit">
    <pictos-form :doc="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import PictosForm from "./PictosForm";
import router from "@/router";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserPictosEdit",
  components: {
    PictosForm,
  },
  data() {
    return {
      doc: {},
    };
  },
  created() {
    const ref = fb.signsCollection.doc(this.$route.params.edit);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const ref = fb.signsCollection.doc(to.params.edit);

    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const updateRef = fb.signsCollection.doc(this.$route.params.edit);
      updateRef
        .set(this.doc)
        .then(() => {
          this.doc = {};
          router.push({ name: 'UserPictos' });
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
